import React from "react";

class UserSelect extends React.Component {

  constructor(props) {
    super(props)
  }

  componentDidMount() {
    this.initSelect2();
  }
  
  componentDidUpdate(prevProps) {
    if (this.props.room != prevProps.room) {
      this.initSelect2()
    }
  }

  initSelect2() {
    var self = this;
    if (this.refs.user) {
      $(this.refs.user).select2({
        ajax: {
          url: '/admin/users_remote',
          dataType: 'json',
          delay: 250,
          data: function (params) {
            return {
              q: params.term,
              page: params.page,
              results_per_page: 40,
              menu_item: self.props.menu_item
            };
          },
          processResults: function (data, params) {
            params.page = params.page || 1;

            return {
              results: data.items,
              pagination: {
                more: (params.page * 40) < data.total_count
              }
            };
          },
          cache: true
        },
        allowClear: true,
        escapeMarkup: function (markup) {
          return markup;
        },
        placeholder: I18n.t('select_ellipsis'),
        templateResult: function (user) {
          if (user.loading || user.id == '') {
            return user.text;
          }

          return user.name
        },
        templateSelection: function (user) {
          if (user && user.id != null && user.id != '') {
            user.header = self.props.name
            self.props.onChange(user);
            if (user.name) {
              return user.name
            } else {
              return user.text
            }
          } else {
            return user.text
          }
        }
      }).on('select2:unselect', function () {
        if (self.props.name) {
          var room = {header: self.props.name, name: null}
          self.props.onChange(room);
        } else {
          self.props.onChange(null);
        }
      });
    }
  }

  render() {
    var disabled_text = ""
    var name = ""
    
    if (this.props.user && this.props.user.name) {
      name = this.props.user.name 
    } else if (this.props.user && this.props.user.first_name && this.props.user.last_name) {
      name = this.props.user.first_name + " " + this.props.user.last_name
    } else if (this.props.user) {
      name = this.props.user.text
    }

    if (this.props.className) {
      var className = `user-select ${this.props.className}`
    } else {
      var className = 'user-select'
    }

    if (this.props.user && this.props.user.status == "inactive") {
      disabled_text = '(<i>' + I18n.t('inactive') + '</i>)'
    }
    
    return (
      <div>
        <div className={className}>
          <select className="form-control" ref="user" style={{ width: '100%', minHeight: 33 }} name={this.props.name}>
            {
              this.props.user ? <option value={this.props.user.id}>{name} {disabled_text}</option> : null
            }
          </select>
        </div>
        {
          typeof this.props.renderErrors === 'function'
            ?
            this.props.renderErrors('assigned_to_id')
            :
            null
        }
        {this.renderFieldError()}
      </div>
    );
  }

  renderFieldError() {
    if (this.props.errors) {
      $('.user-select').find('.select2-container--default .select2-selection--single .select2-selection__rendered').addClass(this.props.renderFieldClasses('assigned_to_id'))
    } else if (this.props.fieldClassError) {
      $(`.${this.props.className}`).find('.select2-container--default .select2-selection--single .select2-selection__rendered').addClass('has-errors')
    }

    
    if (this.props.hasError && this.props.hasError.includes('has-errors')) {
      if ($(".user-select").find('.select2-container--default .select2-selection--single .select2-selection__rendered')[0] && !$(".user-select").find('.select2-container--default .select2-selection--single .select2-selection__rendered')[0].className.includes('has-errors')) {
        $(".user-select").find('.select2-container--default .select2-selection--single .select2-selection__rendered')[0].className += this.props.hasError
      }
    }
    if (this.props.hasError == "no error") {
      if ($(".user-select").find('.select2-container--default .select2-selection--single .select2-selection__rendered')[0] && $(".user-select").find('.select2-container--default .select2-selection--single .select2-selection__rendered')[0].className.includes('has-errors')) {
        var select = $(".user-select").find('.select2-container--default .select2-selection--single .select2-selection__rendered')[0]
        select.className = select.className.replace(/has-errors/g, "")
      }
    }
    
  }

};

export default UserSelect